/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Entry } from "contentful";
import { ContentBlock, GuideTypes, Metadata } from "../models";
import { containsSubset } from "./mapEntryItems";
import { storeContentfulDebuggingInfo } from "./storeContentfulDebuggingInfo";

export const findContent = (
  entries: Entry<ContentBlock & Metadata>[],
  id: string | undefined,
  guideType: GuideTypes,
) => {
  const entry = entries.find(
    item =>
      item.fields.id === id &&
      containsSubset(item.fields.guideType, [guideType]),
  );

  if(typeof entry !== "undefined" && entry?.fields.id){
    storeContentfulDebuggingInfo(entry);
  }

  return entry;
}
